import { useEffect, useState } from 'react'

export function NetworkStatus() {
  const [online, setOnline] = useState(() => navigator.onLine)

  useEffect(() => {
    const markOnline = () => setOnline(true)
    const markOffline = () => setOnline(false)
    window.addEventListener('online', markOnline)
    window.addEventListener('offline', markOffline)
    return () => {
      window.removeEventListener('online', markOnline)
      window.removeEventListener('offline', markOffline)
    }
  }, [])

  if (online) return null

  return (
    <div role="status" className="fixed bottom-4 left-1/2 z-[100] -translate-x-1/2 rounded-full border border-warning-200 bg-warning-50 px-4 py-2 text-sm font-medium text-notice shadow-lg">
      Sei offline. Vedi i dati già caricati; le modifiche richiedono la connessione.
    </div>
  )
}
